export const SITE_URL = "https://dollclothesbyellawise.com";
export const SITE_NAME = "Doll Clothes by Ella Wise";
export const TITLE = "Handmade 18-Inch Doll Clothes in Midland, MI | Doll Clothes by Ella Wise";
export const DESCRIPTION =
  "Handmade doll clothes for 18-inch dolls — knit, crocheted, and sewn by hand in Midland, Michigan. Browse the collection or ask about personalized, made-to-order gifts.";
export const THEME_COLOR = "#faf6f0";
export const PHONE_E164 = "+19893883556";
export const PHONE_DISPLAY = "989-388-3556";
export const EMAIL = "wisella@aol.com";
export const LOCALITY = "Midland";
export const REGION = "MI";
export const GOOGLE_REVIEWS_URL = "https://share.google/2rmXyLbPZTZmHAgWV";
export const OG_IMAGE_PATH = "/og-image.jpg";
export const OG_IMAGE_ALT =
  "Handmade coral crochet doll dress with white scalloped trim, a rosette headband and white crochet booties";

export function absUrl(path = "/"): string {
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export const OG_IMAGE = absUrl(OG_IMAGE_PATH);
